module.exports = __webpack_public_path__ + "img/atitude-de-dono.50d4c4a8.jpg";